/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { useScrollDirection } from '@apps/config/windowscroll.config';
import { CategoriesBoxWrapper } from '@apps/layouts/Navbar/styles';
import { Box } from '@mui/material';
import { TitleDivider } from '@stack/ui/components';

import { CarOverviewHeaderNavBarItem } from '../CarOverviewHeaderNavBarItem';
import { CarOverviewNavItemRefProps } from '../CarOverviewHeaderNavBarItem/props';
import { CarOverviewNavBarItem } from '../CarOverviewHeaderNavBarItem/settings';
import { CarOverviewSectionContent } from '../CarOverviewSectionContent';
import { CarOverviewSectionContentRefProps } from '../CarOverviewSectionContent/props';

export type CarDescription = {
  new_car_description_value: string;
};

export type CarSetting = {
  new_car_setting_description_name: string;
  new_car_setting_description_sub: {
    new_car_description: CarDescription;
  }[];
};

export type CarOverviewProps = {
  data: CarSetting[];
};

// ==== LAYOUT
export interface SectionHandle {
  scrollToSection: (key: string) => void;
  container: HTMLDivElement | null;
}

const CarOverview: React.FC<CarOverviewProps> = (props) => {
  const { data } = props;
  const containerRef = useRef<HTMLDivElement | null>(null);
  const navHeaderRef = useRef<HTMLDivElement | null>(null);
  const sectionRef = useRef<CarOverviewSectionContentRefProps>(null);
  const navItemRef = useRef<CarOverviewNavItemRefProps>(null);
  const scrollDirection = useScrollDirection();

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    key: CarOverviewNavBarItem
  ) => {
    event.preventDefault();
    // navItemRef.current?.setFocusedNavItem(key);
    sectionRef.current?.scrollToSection(key);
  };

  const renderNavItem = () => {
    return (
      <div
        style={{
          borderBottom: '1px solid #ECECEC',
          position: 'relative',
          backgroundColor: 'white',
        }}
      >
        <CategoriesBoxWrapper $show={scrollDirection !== 'down'}>
          <CarOverviewHeaderNavBarItem
            ref={navItemRef}
            handleClick={handleClick}
          />
        </CategoriesBoxWrapper>
      </div>
    );
  };

  return (
    <TitleDivider title="Reviews">
      <Box sx={{ border: '1px solid #ECECEC', position: 'relative' }}>
        {renderNavItem()}
        <Box
          ref={containerRef}
          id="carOverviewContainer"
          sx={{
            position: 'relative',
            maxHeight: '600px',
            overflowY: 'auto',
            width: '100%',
            '::-webkit-scrollbar': {
              width: '6px',
            },
            '::-webkit-scrollbar-thumb': {
              backgroundColor: '#31ACBF',
              borderRadius: '50px',
            },
            '::-webkit-scrollbar-thumb:hover': {
              background: '#31ACBF',
            },
          }}
        >
          {/* Nav Bar */}
          <Box
            sx={{
              backgroundColor: '#FFFFFF',
              overflow: 'none',
            }}
            ref={navHeaderRef}
          >
            <div style={{ overflow: 'hidden' }}>
              <CarOverviewSectionContent
                ref={sectionRef}
                containerRef={containerRef}
                navHeaderRef={navHeaderRef}
                navItemRef={navItemRef}
                data={data}
              />
            </div>
          </Box>
        </Box>
      </Box>
    </TitleDivider>
  );
};

export default CarOverview;
